import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import useLocalStorage from "@hooks/useLocalStorage";

/**
 * @deprecated
 */
export var api__getIsWorkingTime_depricated = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref2, _res$data, _res$data$data, _res$data$data$contac;
    var _useLocalStorage, setLocalStorage, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _useLocalStorage = useLocalStorage(), setLocalStorage = _useLocalStorage.setLocalStorage;
          _context.next = 3;
          return fetcher().post("/site/popup-campaign?include=contact");
        case 3:
          res = _context.sent;
          if (__IS_CSR__ && res.headers['x-country-code']) {
            setLocalStorage('country_code', res.headers['x-country-code']);
          }
          return _context.abrupt("return", (_ref2 = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : (_res$data$data$contac = _res$data$data.contact_us) === null || _res$data$data$contac === void 0 ? void 0 : _res$data$data$contac.is_working_time) !== null && _ref2 !== void 0 ? _ref2 : true);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__getIsWorkingTime_depricated() {
    return _ref.apply(this, arguments);
  };
}();
export var api__getIsWorkingTime = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _ref4, _res$data2;
    var _useLocalStorage2, setLocalStorage, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _useLocalStorage2 = useLocalStorage(), setLocalStorage = _useLocalStorage2.setLocalStorage;
          _context2.next = 3;
          return fetcher().get("/site/check-working-hours?hour=".concat(new Date().getHours()));
        case 3:
          res = _context2.sent;
          if (__IS_CSR__ && res.headers['x-country-code']) {
            setLocalStorage('country_code', res.headers['x-country-code']);
          }
          return _context2.abrupt("return", (_ref4 = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data.is_working_time) !== null && _ref4 !== void 0 ? _ref4 : true);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function api__getIsWorkingTime() {
    return _ref3.apply(this, arguments);
  };
}();